import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  FormContainer,
  NextButton,
  Prompt,
  QuestionContainer,
  QuestionPageContainer,
  StringInput,
} from "~/OnboardingApp/components";
import { useOnboarding } from "~/OnboardingApp/hooks/useOnboarding";
import { useSubmitOnboardingQuestion } from "~/OnboardingApp/hooks/useSubmitOnboardingQuestion";
import { string } from "~/utils/validations";

type Values = {
  employer: string;
};

const validationSchema = Yup.object({
  employer: string,
});

export const EmployerPage: FC = () => {
  const { t } = useTranslation();
  const { employer } = useOnboarding();
  const { onSubmit } = useSubmitOnboardingQuestion();

  const initialValues: Values = {
    employer: employer || "",
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
  });

  return (
    <QuestionPageContainer>
      <FormContainer formik={formik}>
        <QuestionContainer>
          <Prompt
            description={t("onboarding.employerPage.description")}
            question={t("onboarding.employerPage.question")}
          />

          <StringInput
            id="employer"
            placeholder={t("onboarding.employerPage.placeholder")}
          />
        </QuestionContainer>

        <NextButton />
      </FormContainer>
    </QuestionPageContainer>
  );
};
